import getVisitorOptions from './getVisitorOptions';
import { getVisitorType } from './five9VisitorTypes';
import { FIVE9_WEBCHAT_OPEN_CLASSNAME } from './shouldLoadOnlineChat';

/**
 * Loads Five9 Widget script into page dom body
 *
 * @returns {Promise} Promise that resolves once Five9 Widget script is loaded onto page dom
 */
const loadFive9Widget = () =>
  new Promise((resolve, reject) => {
    let onlineChatScript = document.createElement('script');
    onlineChatScript.type = 'text/javascript';
    onlineChatScript.src =
      'https://app.five9.com/consoles/SocialWidget/five9-social-widget.min.js';
    onlineChatScript.onload = resolve;
    onlineChatScript.onerror = reject;

    document.body.appendChild(onlineChatScript);
  });

/**
 * Helper function to set the display style on the five9 frame, used to show and hide the frame
 *
 * @param {String} displayStyle display style to set to frame
 */
const setFive9FrameDisplayStyle = (displayStyle) => {
  let five9Frame = document.getElementsByClassName('five9-frame');
  if (five9Frame && five9Frame[0]) {
    five9Frame[0].style.display = displayStyle;
  }
};

/**
 * Eventlistener that will show the entire frame and then trigger a click event to maximize the chat frame
 *
 * @param {Event} event event object to pass into listener
 */
const maximizeChat = (event) => {
  event.preventDefault();
  setFive9FrameDisplayStyle('block');
  let maximizeButton = document.getElementById('five9-maximize-button');
  if (maximizeButton) {
    maximizeButton.click();
  }
};

/**
 * Initialize client-facing online chat functionality
 *
 * @returns {Promise} Promise that resolves once Five9 Widget is loaded and configured
 */
export const initOnlineChat = async () => {
  await loadFive9Widget();
  const visitorType = getVisitorType();
  const currentVisitorOptions = getVisitorOptions(visitorType);
  const options = {
    rootUrl: 'https://app.five9.com/consoles/',
    type: 'chat',
    tenant: 'Alaska Airlines.',
    showProfiles: false,
    autostart: false,
    surveyOptions: {
      showComment: false,
      requireComment: false,
    },
    playSoundOnMessage: true,
    allowCustomerToControlSoundPlay: true,
    showEmailButton: false,
    hideDuringAfterHours: false,
    useBusinessHours: true,
    showPrintButton: false,
    allowUsabilityMenu: false,
    enableCallback: false,
    callbackList: '',
    done: () => {},
    allowRequestLiveAgent: false,
    ...currentVisitorOptions,
  };

  // Add five9 chat widget to the page
  // eslint-disable-next-line no-undef
  Five9SocialWidget.addWidget(options);

  // when a "start chat" link is clicked, show the chat frame and automatically maximize it
  let chatStartElement = document.getElementsByClassName(
    FIVE9_WEBCHAT_OPEN_CLASSNAME
  )[0];
  if (chatStartElement) {
    chatStartElement.addEventListener('click', maximizeChat);
  }
};
